'use strict';

module Patersons {

    export class PortfolioSummaryComponent implements ng.IComponentOptions {
        templateUrl: string = 'assets/templates/portfolioSummary/components/portfolioSummary.component.html';
        controller: any = PortfolioSummaryController;
        bindings: any = {
            account: '<',
            isDownloadReady: '<',
            summaryText: '@',
            onDownloadPdfClicked: '&',
            onDownloadCsvClicked: '&',
            hidePdfOption: '<',
            hideCsvOption: '<'
        };
    }

    export class PortfolioSummaryController {
        account: Account;
        isDownloadReady: boolean;
        summaryText: string;
        hidePdfOption: boolean;
        hideCsvOption: boolean;
    }
}